import { TemplateRef, ViewContainerRef, Directive, Input} from "@angular/core";
import { AuthService } from "./auth.service";

@Directive({
    selector: '[appHasClaim]',
    standalone: false
})
export class HasClaimDirective {

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private authService: AuthService    
  ) { }

  @Input("appHasClaim") set hasClaim(claimType: any) {
    this.authService.hasClaim(claimType).subscribe(e => {
      if (e) {
        this.viewContainer.createEmbeddedView(this.templateRef);
      } else {
        this.viewContainer.clear();
      }
    });
  }

}
